module.exports = __webpack_public_path__ + "img/VIB.a4ee7bb8.svg";